<h1 mat-dialog-title>Terms of Use for Patients</h1>
<div mat-dialog-content>
  <small>Last Modified: May 6, 2018</small>
  <section>
    <p>
      <strong
        >IF YOU ARE EXPERIENCING A MEDICAL EMERGENCY, PLEASE CONTACT YOUR LOCAL
        EMERGENCY SERVICES OR DIAL 9-1-1 ON YOUR TELEPHONE. PATIENTPAL DOES NOT
        PROVIDE EMERGENCY SERVICES.</strong
      >
    </p>
  </section>

  <section>
    <h2>Acceptance of these Terms of Use</h2>
    <p>
      These terms of use are entered into by and between you (“you” or the
      “Patient”) and PatientPal, Inc ("Company,” “we” or “us”). The following
      terms and conditions, together with any documents they expressly
      incorporate by reference (collectively, these “Terms of Use”), govern your
      access to and use of the PatientPal website and web application, including
      any content, functionality, and services offered on or through PatientPal.
    </p>
    <p>
      Please read these Terms of Use carefully before you start to use
      PatientPal. This is a legally binding agreement and the equivalent of a
      signed, written contract.
    </p>
    <p>
      By clicking to agree to these Terms of Use when this option is made
      available to you, you represent that you have read and considered these
      Terms of Use, and that you accept and agree to be bound and abide by these
      Terms of Use.
    </p>
    <p>
      Following your agreement to these Terms of Use, you will be asked to
      review, consider, and agree to our Privacy Policy (which can be viewed by
      clicking here), which (along with any revisions thereto) is incorporated
      herein by reference. Once you have indicated your agreement, a copy of
      each document will be sent to the email address on file with your
      PatientPal account.
    </p>
    <p>
      You will not be allowed to access or use PatientPal unless you indicate
      your agreement to these Terms of Use and the Privacy Policy. Following any
      revision to these Terms of Use or the Privacy Policy, you will not be
      allowed to continue to access or use PatientPal unless you indicate your
      agreement to the revised Terms of Use or Privacy Policy.
    </p>
    <p>
      If you do not want to agree to these Terms of Use or the Privacy Policy or
      to any revision of any of these documents, then you must not access or use
      PatientPal.
    </p>
    <p>
      PatientPal is offered and available to users who are 18 years of age or
      older, and reside in the United States or any of its territories or
      possessions. By using PatientPal, you represent and warrant that you are
      of legal age to form a binding contract with Company and meet all of the
      foregoing eligibility requirements. If you do not meet all of these
      requirements, you must not access or use PatientPal.
    </p>
  </section>
  <section>
    <h2>Definitions</h2>
    <p>
      <strong>Patient</strong>. You are the Patient – the individual who will
      interact with PatientPal to provide important information to a Provider in
      preparation for a healthcare appointment.
    </p>
    <p>
      <strong>Patient</strong> Information. All identifiable information and
      documents that are communicated or uploaded to PatientPal by you or your
      Provider, and all identifiable information and documents that PatientPal
      develops as a result, comprise the Patient Information. Patient
      Information includes, without limitation, the Patient’s
      insurance/billing/payment information, and the Patient’s PatientPal
      account information to the extent it can be used to identify you.
    </p>
    <p>
      <strong>PatientPal</strong>. PatientPal is a website and web application
      that streamlines patient billing and other health care administrative
      systems.
    </p>
    <p>
      <strong>Provider</strong>. A Provider is any healthcare provider,
      practice, clinic, facility, or hospital that has signed up to use
      PatientPal in connection with one or more Patients.
    </p>
  </section>
  <section>
    <h2>
      <span class="company-name">Company</span> and PatientPal are Not A Health
      Care Providers
    </h2>
    <p>
      <span class="company-name">Company</span> helps Providers by streamlining
      Patient billing, insurance reimbursements, and other administrative
      functions. <span class="company-name">Company</span> is not a health care
      provider, and we will not provide you with health care advice. Any health
      care advice that a Provider communicates to you is solely the
      responsibility of that Provider. You agree that you shall not rely on
      PatientPal, and that PatientPal shall have no responsibility or liability,
      for the truth, accuracy, or efficacy of any diagnosis, treatment plan,
      prescription, treatment (as well as any decision not to conduct
      treatment), or any other form of medical or health care that is developed,
      discussed, or otherwise communicated or conducted in connection with the
      use of PatientPal.
    </p>
  </section>
  <section>
    <h2>Do Not Use PatientPal to Obtain Emergency Services or Urgent Care</h2>
    <p>
      PatientPal does not provide or facilitate emergency services or urgent
      care. If you are experiencing a medical emergency or other urgent health
      issue, do NOT attempt to obtain emergency or urgent medical care through
      PatientPal. Please call 9-1-1 on your telephone, contact your local
      emergency or urgent care service providers directly by phone.
    </p>
  </section>
  <section>
    <h2>Changes to these Terms of Use</h2>
    <p>
      We may revise and update these Terms of Use from time to time in our sole
      discretion. All changes are effective immediately when we post them, and
      apply to all access to and use of PatientPal thereafter.
    </p>
    <p>
      We will notify you of changes to these Terms of Use by means of the email
      address on record with your PatientPal account. To continue using or
      accessing PatientPal, you will be required to agree to such revised Terms
      of Use.
    </p>
  </section>
  <section>
    <h2>Grant of Access</h2>
    <p>
      <span class="company-name">Company</span> grants you access to use
      PatientPal. This grant is conditioned on your continued compliance with
      these Terms of Use. You may not assign, lease, lend, sell, transfer,
      redistribute, or license PatientPal. You may not copy, decompile,
      reverse-engineer, disassemble, attempt to derive the source code of,
      modify, or create derivative works of PatientPal, any updates, or any part
      thereof (except as and only to the extent that any foregoing restriction
      is prohibited by applicable law or to the extent as may be permitted by
      the licensing terms governing use of any open-sourced components included
      with PatientPal).
    </p>
  </section>
  <section>
    <h2>Patient Information and Privacy</h2>
    <p>
      The main purpose of PatientPal is to help create preliminary documentation
      about you for your Provider(s) to streamline treatment and billing. To do
      so, PatientPal will ask you questions to elicit personal information,
      including health and insurance information, and may ask you to upload
      health-related documents. Your Provider may also provide Patient
      Information to PatientPal, such as information from your medical record
      maintained by your Provider. Because PatientPal is offered to you on
      behalf of your Provider,
      <span class="company-name">Company</span> protects your Patient
      Information in accordance with the Health Insurance Portability and
      Accountability Act (“HIPAA”) of 1996, as amended.
      <span class="company-name">Company</span> will only use or disclose your
      Patient Information as permitted by HIPAA and our agreement with your
      Provider (which may include activities related to
      <span class="company-name">Company’s</span> own management and
      administrative purposes and legal responsibilities). Information that has
      been de-identified (as defined by HIPAA) does not constitute Patient
      Information and may be used or disclosed by
      <span class="company-name">Company</span> in any lawful manner.
    </p>
    <p>
      You understand that Patient Information that you provide via PatientPal
      may be made part of your permanent medical record at the discretion of
      your Provider. We cannot, however, ensure that your Providers will protect
      the privacy or confidentiality of your Patient Information. By agreeing to
      these Terms of Use, you accept the risk that the privacy and
      confidentiality of your Patient Information may be violated by your
      Providers, and you acknowledge and agree that
      <span class="company-name">Company</span> will bear no responsibility for
      the conduct of your Providers. We recommend that you review your
      Provider’s Notice of Privacy Practices to understand how your Provider
      protects your Patient Information.
    </p>
  </section>
  <section>
    <h2>Electronic Signatures</h2>
    <p>
      You agree to be bound by any affirmance, assent, or agreement that you
      transmit to <span class="company-name">Company</span> using PatientPal,
      including but not limited to any consent you give to receive
      communications from <span class="company-name">Company</span> solely
      through electronic transmission. You agree that, when in the future you
      click on an “I agree,” “I consent,” or other similarly worded “button” or
      entry field in PatientPal, your agreement or consent will be legally
      binding and enforceable and the legal equivalent of your handwritten
      signature.
    </p>
  </section>
  <section>
    <h2>Carrier Charges</h2>
    <p>
      Your carrier’s data rates may apply to your use of PatientPal. Please
      check with your carrier if you have questions about your plan and costs.
    </p>
  </section>
  <section>
    <h2>Accessing PatientPal and Account Security</h2>
    <p>
      We reserve the right to withdraw or amend PatientPal, and any service or
      material we provide on PatientPal, in our sole discretion without notice.
      From time to time, we may restrict access to some or all parts of
      PatientPal to users, including registered users.
    </p>
    <p>
      You acknowledge and agree that we are not responsible and shall not be
      liable for any injury, inconvenience, or other damages caused by all or
      any part of PatientPal being unavailable at any time or for any period.
    </p>
    <p>You are responsible for:</p>
    <ul>
      <li>
        Making all arrangements necessary for you to have access to PatientPal.
      </li>
      <li>
        Ensuring that all persons who access PatientPal through your internet or
        cellular data connection are aware of these Terms of Use and comply with
        them.
      </li>
      <li>
        Ensuring that we have your correct contact information, including your
        email address, phone number, and mailing address, and that you inform us
        promptly of any changes in your contact information. Failure to do so
        may cause you not to receive critical information about your health
        care, and critical notifications about changes to these Terms of Use or
        other policies that govern your use of PatientPal.
      </li>
    </ul>
    <p>
      You acknowledge and agree that we are not responsible and shall not be
      liable for any injury, inconvenience, or other damages caused by your
      failure to maintain accurate and current contact information.
    </p>
    <p>
      To access PatientPal or some of the resources it offers, you may be asked
      to provide certain registration details or other information. It is a
      condition of your use of PatientPal that all the information you provide
      on PatientPal is correct, current, and complete. You agree that all
      information you provide to register with PatientPal or otherwise,
      including but not limited to through the use of any interactive features
      on PatientPal, is governed by the Privacy Policy, these Terms of Use, and
      our agreements with your Provider(s), and you consent to all actions we
      take with respect to your information that are consistent with those
      documents.
    </p>
    <p>
      If you choose, or are provided with, a user name, password, or any other
      piece of information as part of our security procedures, you must treat
      such information as confidential, and you must not disclose it to any
      other person or entity. You also acknowledge that your account is personal
      to you and agree not to provide any other person with access to PatientPal
      or portions of it using your user name, password, or other security
      information. You agree to notify us immediately if there is any
      unauthorized access to or use of your user name or password or any other
      breach of security. You also agree to ensure that you exit from your
      account at the end of each session. You should use particular caution when
      accessing your account from a computer or mobile device that is not your
      own, so that others are not able to view or record your password or other
      personal information.
    </p>
    <p>
      We have the right to disable any user name, password, or other identifier,
      whether chosen by you or provided by us, at any time in our sole
      discretion for any or no reason, including if, in our opinion, you have
      violated any provision of these Terms of Use.
    </p>
  </section>
  <section>
    <h2>Intellectual Property Rights</h2>
    <p>
      PatientPal and its entire contents, features, and functionality (including
      but not limited to all information, software, text, displays, images,
      video, and audio, and the design, selection, and arrangement thereof), are
      owned by <span class="company-name">Company</span>, its licensors, or
      other providers of such material and are protected by United States and
      international copyright, trademark, patent, trade secret, and other
      intellectual property or proprietary rights laws.
    </p>
    <p>
      These Terms of Use permit you to use PatientPal for your personal,
      non-commercial use only. Other than as necessary to use PatientPal in
      accordance with these Terms of Use, you must not reproduce, distribute,
      modify, create derivative works of, publicly display, publicly perform,
      republish, download, store, or transmit any of the material on our website
      or web application (except for Patient Information), including without
      limitation any text, illustrations, photographs, graphics, video, or audio
      sequences (“Content”).
    </p>
    <p>Further, you must not:</p>
    <ul>
      <li>Modify copies of any materials from PatientPal.</li>
      <li>
        Use any Content from PatientPal in any context except within PatientPal.
      </li>
      <li>
        Delete or alter any copyright, trademark, or other proprietary rights
        notices from copies of materials from this site.
      </li>
    </ul>
    <p>
      You must not access or use for any purposes, commercial or otherwise, any
      part of PatientPal or any services or materials available through
      PatientPal, except for the intended purposes as described in these Terms
      of Use.
    </p>
    <p>
      If you print, copy, modify, download, or otherwise use or provide any
      other person with access to any part of PatientPal except as expressly
      permitted by these Terms of Use, your right to use PatientPal will cease
      immediately. No right, title, or interest in or to PatientPal or any
      content on PatientPal is transferred to you, and all rights not expressly
      granted are reserved by <span class="company-name">Company</span>. Any use
      of PatientPal not expressly permitted by these Terms of Use is a breach of
      these Terms of Use and may violate copyright, trademark, and other laws.
    </p>
    <p>
      You further acknowledge that ownership of any improvements in or to
      PatientPal or any new programs, upgrades, modifications or enhancements,
      even when such refinements result from your submission, feedback, or
      request, are and shall remain vested solely in
      <span class="company-name">Company</span>.
    </p>
  </section>
  <section>
    <h2>Trademarks</h2>
    <p>
      “PatientPal,” the PatientPal logo, and all related names, logos, product
      and service names, designs, and slogans are trademarks of
      <span class="company-name">Company</span> or its affiliates or licensors.
      You must not use such marks without the prior written permission of
      <span class="company-name">Company</span>. All other names, logos, product
      names, service names, designs, and slogans on PatientPal are the
      trademarks of their respective owners.
    </p>
  </section>
  <section>
    <h2>Prohibited Uses</h2>
    <p>
      You may use PatientPal only for lawful purposes and in accordance with
      these Terms of Use. You agree that:
    </p>
    <ul>
      <li>
        You will not use PatientPal in any way that violates any applicable
        federal, state, local, or international law or regulation (including,
        without limitation, any laws regarding the export of data or software to
        and from the US or other countries, and any law governing the privacy or
        security of health information, such as HIPAA, or that would cause
        <span class="company-name">Company</span> to violate any such law or
        regulation).
      </li>
      <li>
        You will not use PatientPal to exploit, harm, or attempt to exploit or
        harm minors in any way by exposing them to inappropriate content, asking
        for personally identifiable information, or otherwise.
      </li>
      <li>
        You will not use any electronic communication feature of PatientPal for
        any purpose that is unlawful, tortious, abusive, intrusive on another’s
        privacy, harassing, libelous, defamatory, embarrassing, obscene,
        threatening, or hateful.
      </li>
      <li>
        You will not use PatientPal to upload, post, reproduce, or distribute
        any information, software, or other material protected by copyright,
        trademark, trade secret, patent or any other intellectual property or
        proprietary right (as well as rights of publicity and privacy) without
        first obtaining the permission of the owner of such rights.
      </li>
      <li>
        You will only use PatientPal to collect, store, or transmit information
        about yourself.
      </li>
      <li>
        You will not use PatientPal for any commercial purpose not expressly
        approved by <span class="company-name">Company</span> in writing. You
        will not use PatientPal to upload, post, email, or otherwise transmit
        any advertising or promotional materials, including without limitation
        “junk mail,” “surveys,” “spam,” “chain letters,” “pyramid schemes,” or
        any other form of solicitation or unauthorized communication.
      </li>
      <li>
        You will not upload, post, email, or otherwise transmit any material
        that contains viruses or any other computer code, files, or programs
        that might interrupt, limit, or interfere with the functionality of any
        computer software or hardware or telecommunications equipment.
      </li>
      <li>
        You will not use PatientPal when you are driving a motor vehicle, even
        if doing so is legally permitted in your location.
      </li>
      <li>
        You will not impersonate or attempt to impersonate
        <span class="company-name">Company</span>, an
        <span class="company-name">Company</span> employee, another user, or any
        other person or entity (including without limitation by using e-mail
        addresses or screen names associated with any of the foregoing).
      </li>
      <li>
        You will not engage in any other conduct that restricts or inhibits
        anyone’s use or enjoyment of PatientPal, or that, as determined by us,
        may harm <span class="company-name">Company</span> or users of
        PatientPal or expose them to liability.
      </li>
    </ul>
    <p>Additionally, you agree not to:</p>
    <ul>
      <li>
        Use PatientPal in any manner that could disable, overburden, damage, or
        impair the site or interfere with any other party’s use of PatientPal,
        including their ability to engage in real time activities through
        PatientPal.
      </li>
      <li>
        Use any robot, spider, or other automatic device, process, or means to
        access PatientPal for any purpose, including monitoring or copying any
        of the material on PatientPal.
      </li>
      <li>
        Use any manual process to monitor or copy any of the material on
        PatientPal or for any other unauthorized purpose without our prior
        written consent.
      </li>
      <li>
        Use any device, software, or routine that interferes with the proper
        working of PatientPal.
      </li>
      <li>
        Attempt to gain unauthorized access to, interfere with, damage, or
        disrupt any parts of PatientPal, the server on which PatientPal is
        stored, or any server, computer, or database connected to PatientPal.
      </li>
      <li>
        Attack <span class="company-name">Company</span> or PatientPal via a
        denial-of-service attack or a distributed denial-of-service attack.
      </li>
      <li>
        Otherwise attempt to interfere with the proper working of PatientPal.
      </li>
    </ul>
  </section>
  <section>
    <h2>Your Right to Terminate</h2>
    <p>
      You may terminate your PatientPal account for any reason and at any time
      by notifying us at
      <a href="mailto:deleteme@patientpal.com">deleteme&#64;patientpal.com</a>.
      Please include your full name and the clinic you had service at.
    </p>
  </section>
  <section>
    <h2>
      Monitoring and Enforcement; Termination by
      <span class="company-name">Company</span>
    </h2>
    <p>We have the right to:</p>
    <ul>
      <li>
        Take appropriate legal action, including without limitation, referral to
        law enforcement, for any illegal or unauthorized use of PatientPal.
      </li>
      <li>
        Terminate or suspend your access to all or part of PatientPal for any or
        no reason, including without limitation, any violation of these Terms of
        Use subject to our agreement with your Provider.
      </li>
    </ul>
    <p>
      Without limiting the foregoing, we have the right to fully cooperate with
      any law enforcement authorities or court order requesting or directing us
      to disclose the identity or other information of anyone posting any
      materials on or through PatientPal. YOU WAIVE AND HOLD HARMLESS
      <span class="company-name">Company</span> FROM ANY CLAIMS RESULTING FROM
      ANY ACTION TAKEN BY <span class="company-name">Company</span> DURING OR AS
      A RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS TAKEN AS A CONSEQUENCE
      OF INVESTIGATIONS BY EITHER <span class="company-name">Company</span> OR
      LAW ENFORCEMENT AUTHORITIES.
    </p>
    <p>
      All electronic communications using PatientPal shall be encrypted. While
      <span class="company-name">Company</span> has endeavored to create a
      secure and reliable platform, you acknowledge that there is nevertheless a
      risk that data, including email, electronic communications, and personal
      data, may be accessed by unauthorized third parties when communicated
      between you and <span class="company-name">Company</span> or between you
      and other parties. Your use of the internet is solely at your own risk.
    </p>
    <p>
      <span class="company-name">Company</span>, its affiliates, and its agents
      may monitor your use of PatientPal to evaluate the quality of service you
      receive, your compliance with these Terms of Use, the security of
      PatientPal, or for other reasons. You agree that such monitoring
      activities will not entitle you to any cause of action or other right with
      respect to the manner in which
      <span class="company-name">Company</span> or its affiliates or agents
      monitor your use of PatientPal and enforces or fails to enforce these
      Terms of Use or any other agreement. In no event will
      <span class="company-name">Company</span> or any of its affiliates or
      agents be liable for any costs, damages, expenses, or any other
      liabilities incurred by you as a result of monitoring activities by
      <span class="company-name">Company</span> or its affiliates or agents.
    </p>
    <p>
      However, we cannot review all material before it is posted on PatientPal,
      and cannot ensure prompt removal of objectionable material after it has
      been posted. Accordingly, we assume no liability for any action or
      inaction regarding transmissions, communications, or content provided by
      any user or third party. We have no liability or responsibility to anyone
      for performance or nonperformance of the activities described in this
      section.
    </p>
    <p>
      <span class="company-name">Company</span> may terminate your account and
      your use of PatientPal for any reason, including, among other things: your
      decision to cancel;
      <span class="company-name">Company’s</span> dissolution; and your
      violation of these Terms of Use. If your account is terminated,
      <span class="company-name">Company</span> may, in its sole discretion,
      delete and destroy any or all data associated with your account, including
      without limitation Patient Information, to the extent allowed by law and
      its agreement with your Providers.
    </p>
  </section>
  <section>
    <h2>Reliance on Information Posted</h2>
    We do not warrant the accuracy, completeness, or usefulness of information
    provided by your Providers or any other third party. Any reliance you place
    on such information is strictly in your discretion and at your own risk. We
    disclaim all liability and responsibility arising from any reliance placed
    on such materials by you or any other PatientPal user, or by anyone who may
    be informed of any of its contents. PatientPal may include content provided
    by third parties, including materials provided by other users, bloggers and
    third-party licensors, syndicators, aggregators, and/or reporting services.
    All statements and/or opinions expressed in these materials, and all
    articles and responses to questions and other content, other than the
    content provided by <span class="company-name">Company</span>, are solely
    the opinions and the responsibility of the person or entity providing those
    materials. These materials do not necessarily reflect the opinion of
    <span class="company-name">Company</span>. We are not responsible or liable
    to you or any third party for the content or accuracy of any materials
    provided by any third parties.
  </section>
  <section>
    <h2>Geographic Restrictions</h2>
    <p>
      <span class="company-name">Company</span> is headquartered in
      Massachusetts in the United States. We provide PatientPal for use only by
      persons located in the United States. We make no claims that PatientPal or
      any of its content is accessible or appropriate outside of the United
      States. Access to PatientPal may not be legal by certain persons or in
      certain countries. If you access PatientPal from outside the United
      States, you do so on your own initiative and are responsible for
      compliance with local laws.
    </p>
  </section>
  <section>
    <h2>Disclaimer of Warranties</h2>
    <p>
      YOUR USE OF PATIENTPAL, ITS CONTENT, AND ANY INFORMATION OR SERVICES
      OBTAINED THROUGH PATIENTPAL IS AT YOUR OWN RISK. PATIENTPAL, ITS CONTENT,
      AND ANY SERVICES OR ITEMS OBTAINED THROUGH PATIENTPAL ARE PROVIDED ON AN
      “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND,
      EITHER EXPRESS OR IMPLIED. NEITHER
      <span class="company-name">Company</span> NOR ANY PERSON ASSOCIATED WITH
      <span class="company-name">Company</span> MAKES ANY WARRANTY OR
      REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY,
      QUALITY, ACCURACY, OR AVAILABILITY OF PATIENTPAL OR ANY INFORMATION OR
      SERVICES TRANSMITTED OR OBTAINED BY MEANS OF PATIENTPAL. WITHOUT LIMITING
      THE FOREGOING, NEITHER <span class="company-name">Company</span> NOR
      ANYONE ASSOCIATED WITH
      <span class="company-name">Company</span> REPRESENTS OR WARRANTS THAT
      PATIENTPAL, ITS CONTENT, OR ANY INFORMATION OR SERVICES OBTAINED THROUGH
      PATIENTPAL WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT
      DEFECTS WILL BE CORRECTED, OR THAT PATIENTPAL OR ANY INFORMATION OR
      SERVICES OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR
      EXPECTATIONS.
    </p>
    <p>
      <span class="company-name">Company</span> HEREBY DISCLAIMS ALL WARRANTIES
      OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING
      BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND
      FITNESS FOR PARTICULAR PURPOSE.
    </p>
    <p>
      THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
      LIMITED UNDER APPLICABLE LAW.
    </p>
  </section>
  <section>
    <h2>Indemnification and Covenant Not To Sue</h2>
    <p>
      You agree to defend, indemnify and hold harmless
      <span class="company-name">Company</span>, its affiliates, licensors and
      service providers, and its and their respective officers, directors,
      managers, members, employees, contractors, agents, licensors, suppliers,
      successors and assigns (each an
      <span class="company-name">“Company</span> Indemnified Party”) from and
      against any claims, liabilities, damages, judgments, awards, losses,
      costs, expenses, penalties, audits, consent decrees, or fees (including
      attorneys’ fees) (collectively, “Claims”) arising out of or relating to
      (i) your negligence or willful misconduct, (ii) your breach or violation
      of any of these Terms of Use, the Privacy Policy, or any other agreement,
      (iii) your failure to maintain the secrecy and security of your login
      information (such as your username and password) or any Patient
      Information, (iv) your use of PatientPal, including, but not limited to,
      any use of PatientPal’s content, services, and products other than as
      expressly authorized in these Terms of Use, or (v) your use of any
      information obtained from PatientPal.
    </p>
    <p>
      You further agree to indemnify, defend, and hold each
      <span class="company-name">Company</span> Indemnified Party harmless from
      and against any Claims brought against such
      <span class="company-name">Company</span> Indemnified Party by any third
      party or parties, in connection with any claim for liability (including
      without limitation medical malpractice liability) arising from or relating
      to the provision of medical or health care, including without limitation
      any diagnosis, prescription, treatment plan, or treatment (including the
      failure to provide treatment), whether or not developed, discussed, or
      otherwise communicated or conducted by means of PatientPal.
    </p>
    <p>
      You agree that you, and your agents, representatives, estate, successors,
      and assigns, shall not seek, sue to obtain, or obtain compensation,
      damages, indemnification, contribution, or other remedy from any
      <span class="company-name">Company</span> Indemnified Party for any
      losses, injuries, harm, or other liabilities that arise from or relate to
      the use of PatientPal by you or any other person or entity in connection
      with your health care, diagnosis, treatment plan, or the provision of
      treatment (or failure to provide treatment), whether or not the result of
      professional malpractice, and including (without limitation) losses,
      injuries, harm, and other liabilities caused by the failure by you or any
      Provider to communicate with each other effectively, accurately, timely,
      or at all.
    </p>
  </section>
  <section>
    <h2>Limitation on Liability</h2>
    <p>
      IN NO EVENT WILL <span class="company-name">Company</span>, ITS AFFILIATES
      OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, MANAGERS,
      MEMBERS, OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER
      ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR
      INABILITY TO USE, PATIENTPAL, ANY WEBSITES LINKED TO IT, ANY CONTENT ON
      PATIENTPAL OR LINKED WEBSITES, OR SUCH OTHER WEBSITES OR ANY SERVICES OR
      ITEMS OBTAINED THROUGH PATIENTPAL OR SUCH LINKED WEBSITES, INCLUDING ANY
      DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
      INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING,
      EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR
      ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND
      WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR
      OTHERWISE, EVEN IF FORESEEABLE, IN EXCESS OF THE AMOUNT THAT YOU HAVE PAID
      TO <span class="company-name">Company</span>.
    </p>
    <p>
      THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR
      LIMITED UNDER APPLICABLE LAW.
    </p>
  </section>
  <section>
    <h2>Governing Law and Jurisdiction</h2>
    <p>
      All matters relating to PatientPal and these Terms of Use and any dispute
      or claim arising therefrom or related thereto (in each case, including
      non-contractual disputes or claims), shall be governed by and construed in
      accordance with the internal laws of the Commonwealth of Massachusetts
      without giving effect to any choice or conflict of law provision or rule.
    </p>
    <p>
      All matters relating to PatientPal and these Terms of Use and any dispute
      or claim arising therefrom or related thereto (in each case, including
      non-contractual disputes or claims) shall be determined by binding
      arbitration before a single arbitrator carried out in accordance with the
      commercial dispute rules of the American Arbitration Association. Such
      arbitration shall be heard in Boston, Massachusetts, and either party may
      enter the final ruling of the arbitrator for judgment in a court of
      competent jurisdiction. The fees of the Association and the arbitrator
      shall be divided equally between the parties, and each party otherwise
      shall pay its own legal fees and related expenses. The arbitrator shall
      have the authority to order any remedies, legal or equitable, which a
      party could obtain from a court of competent jurisdiction based on the
      claims asserted (except attorneys’ fees and costs), and nothing more;
      provided, however, there shall be no authority for a dispute to be
      arbitrated on a class action basis, nor shall consolidation or joinder
      with the claims of another person be permitted. The arbitrator shall
      prepare a written decision setting forth his or her findings of fact and
      law. Subject to the Federal Arbitration Act and other applicable law, the
      arbitrator’s award shall be final and binding, without right of appeal.
      Any party may seek to have judgment entered upon the award by a court of
      competent jurisdiction.
    </p>
  </section>
  <section>
    <h2>Limitation on Time to File Claims</h2>
    <p>
      ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO
      THESE TERMS OF USE OR PATIENTPAL MUST BE COMMENCED WITHIN ONE (1) YEAR
      AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION OR
      CLAIM IS PERMANENTLY BARRED.
    </p>
  </section>
  <section>
    <h2>Waiver and Severability</h2>
    No waiver of by <span class="company-name">Company</span> of any term or
    condition set forth in these Terms of Use shall be deemed a further or
    continuing waiver of such term or condition or a waiver of any other term or
    condition, and any failure of <span class="company-name">Company</span> to
    assert a right or provision under these Terms of Use shall not constitute a
    waiver of such right or provision.
    <p>
      If any provision of these Terms of Use is held by a court or other
      tribunal of competent jurisdiction to be invalid, illegal or unenforceable
      for any reason, such provision shall be eliminated or limited to the
      minimum extent such that the remaining provisions of these Terms of Use
      will continue in full force and effect.
    </p>
  </section>
  <section>
    <h2>Entire Agreement</h2>
    <p>
      These Terms of Use and the Privacy Policy constitute the sole and entire
      agreement between you and <span class="company-name">Company</span> with
      respect to PatientPal and supersede all prior and contemporaneous
      understandings, agreements, representations and warranties, both written
      and oral, with respect to PatientPal.
    </p>
  </section>
  <section>
    <h2>Your Comments and Concerns</h2>
    <p>
      All other feedback, comments, requests for technical support and other
      communications relating to PatientPal should be directed to:
      <a href="mailto:legal@patientPal.com">legal&#64;patientPal.com</a>
    </p>
  </section>
</div>
<mat-divider class="divider"></mat-divider>
<div
  mat-dialog-actions
  class="button-container"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <button mat-stroked-button [mat-dialog-close]="false">
    {{ 'common.cancel' | translate }}
  </button>
</div>
